import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc61254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-cancel p-3" }
const _hoisted_2 = { class: "rule-list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-weight-500 mt-4" }, "\n          両者のトラブル防止のためにも、キャンセルの詳細を記入してください。\n        ", -1))
const _hoisted_4 = { class: "reason-block mt-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-weight-500" }, "アプリからキャンセル", -1))
const _hoisted_6 = {
  key: 0,
  class: "text-size-14 text-mild"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "reason-block mt-4" }
const _hoisted_9 = {
  key: 0,
  class: "text-mild text-size-14 mt-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode("\n        以下のお仕事がキャンセルとなります"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("よろしいですか？\n      ")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "mt-2 modal-responsive-medium text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_FormSelectGroup = _resolveComponent("FormSelectGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_TextAreaGroup = _resolveComponent("TextAreaGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      仕事をキャンセル\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, {
        ref: "vObserver",
        initialValues: _ctx.initialValues
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleMessages, (message, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                key: idx,
                class: _normalizeClass([_ctx.getRuleItemClass(idx), "text-weight-500 text-red text-size-14 caution"])
              }, [
                _createVNode(_component_FeatherIcon, {
                  icon: "alert-triangle",
                  size: "18",
                  class: "caution-icon"
                }),
                _createTextVNode(" " + _toDisplayString(message), 1)
              ], 2))
            }), 128))
          ]),
          _createTextVNode(),
          _hoisted_3,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(),
            _createVNode(_component_ValidationProvider, {
              name: "キャンセル理由",
              rules: "required",
              vid: "selectedReason"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(_component_FormSelectGroup, {
                  label: "キャンセル理由",
                  disabled: _ctx.isCancelDueToInfection,
                  modelValue: _ctx.selectedReason,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedReason) = $event)),
                  appLabelText: "必須",
                  options: _ctx.options,
                  "text-field": "text",
                  "value-field": "value",
                  "validation-state": validationState
                }, null, 8, ["disabled", "modelValue", "options", "validation-state"])
              ]),
              _: 1
            })
          ]),
          _createTextVNode(),
          (!_ctx.isCancelDueToInfection)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode("\n          ※事業所都合によるキャンセルは"),
                _createElementVNode("a", {
                  href: _ctx.externalLink.contact,
                  class: "text-blue"
                }, "問い合わせフォーム", 8, _hoisted_7),
                _createTextVNode("よりご連絡ください\n        ")
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ValidationProvider, {
              name: "事業所担当者へのメッセージ",
              rules: { required: true, max: 2000 },
              vid: "cancelReason"
            }, {
              default: _withCtx((validationState) => [
                _createVNode(_component_TextAreaGroup, {
                  modelValue: _ctx.cancelReason,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cancelReason) = $event)),
                  label: "事業所担当者へのメッセージ(キャンセル理由)",
                  appLabelText: "必須",
                  placeholder: "37.5度以上の発熱が出てしまい、キャンセルいたします。シフト調整をしている中、現場の方々には、ご迷惑をおかけしてしまい大変申し訳ございません。次回からは発生しないよう、体調管理を行ってまいります。何卒、お願い申し上げます。",
                  validationState: validationState,
                  class: "mt-1"
                }, null, 8, ["modelValue", "validationState"])
              ]),
              _: 1
            }),
            _createTextVNode(),
            (!_ctx.isCancelDueToInfection)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "\n            事業所は既にシフトを組んでおり、キャンセルは迷惑をかけるため、キャンセルの詳細およびお詫び文を記入してください。\n          "))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createVNode(_component_AppButton, {
            block: true,
            disabled: _ctx.isExecuting,
            variant: "secondary",
            class: "d-block mt-4",
            onClick: ($event: any) => (handleSubmit(_ctx.openConfirmModal))
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n          キャンセルする\n        ")
            ], undefined, true),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      }, 8, ["initialValues"])
    ]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      visible: _ctx.isShownConfirmModal,
      title: "キャンセルの最終確認",
      "header-class": "font-weight-bold modal-responsive-title",
      "ok-title": "キャンセルする",
      "cancel-title": "やめる",
      "cancel-variant": "gray-03",
      onOk: _ctx.cancelApplication,
      onCancel: _ctx.navigateApplicationDetail,
      onHide: _ctx.closeConfirmModal,
      centered: ""
    }, {
      default: _withCtx(() => [
        _hoisted_10,
        _createTextVNode(),
        _createElementVNode("p", null, "事業所名：" + _toDisplayString(_ctx.officeName), 1),
        _createTextVNode(),
        _createElementVNode("p", null, "日時：" + _toDisplayString(_ctx.formattedDate) + " " + _toDisplayString(_ctx.formattedWorkTimeRange), 1),
        _createTextVNode(),
        (!_ctx.isCancelDueToInfection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "\n        ⚠応募ミスのキャンセルも信用スコアが減点されます\n      "))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }, 8, ["visible", "onOk", "onCancel", "onHide"])
  ]))
}